import React, { useState, useEffect } from "react";
import "./styles/components/App.css";
import { getAssetTypeByRoute, getDefaultAssetType, getAvailableAssetTypes } from "./utils/assetRegistry";

const App = () => {
  const [currentAssetType, setCurrentAssetType] = useState(getDefaultAssetType());

  // Check the URL path on component mount and when it changes
  useEffect(() => {
    const handleRouteChange = () => {
      const path = window.location.pathname;
      const assetType = getAssetTypeByRoute(path === "/" ? "/buildings" : path);
      setCurrentAssetType(assetType);
    };

    // Initial route check
    handleRouteChange();

    // Add event listener for URL changes
    window.addEventListener("popstate", handleRouteChange);

    return () => {
      window.removeEventListener("popstate", handleRouteChange);
    };
  }, []);

  // Handle internal navigation between asset types
  const navigateTo = (route) => {
    window.history.pushState({}, "", route);
    const popStateEvent = new PopStateEvent("popstate", {});
    window.dispatchEvent(popStateEvent);
  };

  // Add this to window object for dropdown links to work
  window.navigateTo = navigateTo;

  // Render the component for the current asset type
  const AssetComponent = currentAssetType.component;

  // Return warning for "coming soon" asset types
  if (currentAssetType.comingSoon) {
    return (
      <div className="App coming-soon-container">
        <h1>{currentAssetType.name} Generator</h1>
        <p>Coming soon! This asset type is under development.</p>
        <button onClick={() => navigateTo('/buildings')}>
          Return to Building Generator
        </button>
      </div>
    );
  }

  return (
    <div className="App">
      {AssetComponent && <AssetComponent />}
    </div>
  );
};

export default App;
